import {ContentTypeEnum} from '../enums/content-type.enum';
import {BaseContentModel} from './base.content-model';

export class HtmlContentModel extends BaseContentModel {

    public fr: string;

    public en: string;

    constructor(options?: Partial<HtmlContentModel>) {
        super(ContentTypeEnum.Html);

        this.fr = options?.fr ?? '';
        this.en = options?.en ?? '';
    }
}
